'use client'

import React from 'react'

import { Icon } from '@sidecar-components/atoms/Icon'
import { SpinnerProps } from './Spinner.types'
/**
 * The Spinner component is used when retrieving data or performing slow
 * computations, and helps to notify users that loading is underway.
 *
 * @param {string} className - Any additional classes to add to the Loading
 * @param {IconSize} size - Size of the icon.
 * @returns
 */
export const Spinner = ({ className = '', size }: SpinnerProps) => {
  return (
    <Icon
      name="loading"
      size={size}
      className={`color-icon-default animate-spin mx-auto ${className}`}
    />
  )
}
